import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=c878f1bc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c878f1bc')) {
      api.createRecord('c878f1bc', component.options)
    } else {
      api.reload('c878f1bc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=c878f1bc&", function () {
      api.rerender('c878f1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QICPjRtoylWi/JS/offershelp.vue"
export default component.exports